<template>
  <div class="ImportHistoryComponent DataTables">
    
    

    <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'ImportHistoryComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        name: 'ImportHistoryComponent',
        mainTable: "",
        id: "ImportHistoryComponent" + this._uid,
        columns: [],
        colsAssign: [],
        imports: [],
        isData: false

      }
  },
  computed: {
    

    

    reloadedAfterAction(){
        return this.$store.getters.reloadedAfterAction;
    },
    variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
            return "light";
        }else{
            return "dark";
        }
    
    }
  },
  created () {

    this.createTable();


  },
  watch: {
    revisionId: {
      handler: function(newVal, oldVal){
        
        this.createTable();
      },
      deep: true
    
      
    },
    
    reloadedAfterAction: function(newValue, oldValue){

      if (newValue.name == this.name){
        if (newValue.status == true){
            
            this.createTable();
            
            newValue.status = false;
            newValue.name = "";
            this.$store.dispatch("reloadAfterAction", newValue);
        }
      }
    }
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    createTable(){
      let vue = this;

             

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getImportedParts")
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          this.imports = result.data;
          vue.isData = true;  
          


          vue.buildColumns();


        }else{
            vue.isData = false;  
        }


      })
    },
    buildColumns(){

      this.columns = [
        {
          name: "Id",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_When,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Category,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Quantity,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Action,
          alignInColumn: "left",
          type: "text"
        },
        
      ]

      this.colsAssign =  [
        { "data": "importId" },
        { "data": "importDate" },
        { "data": "category" },
        { "data": "quantity" },
        { "data": "importId" },
        
               
      ]

      this.buildTable();
    },
    buildTable(){
          

          var tableplace = document.getElementById(this.id);

          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ this.columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }

                
                if (meta.col == 1){
                    return Tools.longDateToShort(data);
                }
                if (meta.col == 4){
                    let str = "<button  class=\"btn btn-secondary btn-sm btn-"+_vue.variant+" button_action_undo\" id=\"button__undo__" + row.importId +"\" >"+_vue.lang.button_Undo+"</button>";

                    return  str;
                }

                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

          }


          var option = {};
          option.paging = true;
          option.info = true;
          option.dom = '<fr<t>ip>';
          option.data= this.imports;
          option.myColumnFormats = this.columns;
          option.select = false;
          option.order = [[1, "desc"]];
          option.lengthMenu = [[20]];
          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.initComplete = function () {


          

          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
             
          }

          var _vue = this;

          this.mainTable = $('#t_'+this.id).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );

                 

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          $("#t_"+this.id + ' tbody').on( 'click', 'button', function (e) {
            
            
            _vue.$store.dispatch("showLoader", { visible: true, text: "wait" });
            let temp = this.id.split("__")



            const obj = {
                importId: temp[2]
            }

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_undoImportedParts", obj)
            .then((result) => {
                console.log(result)

                let obj = {
                    text: _vue.lang.alert_success_undo_imported,
                    time: 5,
                    type: "success"
              }

              _vue.$store.dispatch("showLoader", { visible: false, text: "" });

                if (result.status == "OK"){

                    

                    if (result.data != 1){
                        obj = {
                            text: _vue.lang.alert_error_undo_imported,
                            time: 15,
                            type: "danger"
                        }
                    }else{
                        const reloadObj = {
                            status: true,
                            name: "ImportHistoryComponent"
                        }
                        _vue.$store.dispatch("reloadAfterAction", reloadObj);
                    }
                   
                    
                }else{
                    obj = {
                        text: _vue.lang.alert_error_undo_imported,
                        time: 15,
                        type: "danger"
                    }


                }

                _vue.$store.dispatch("displayFooterAlert", obj);


            })
            .then(function () {

              _vue.$store.dispatch("showLoader", { visible: false });

            })

          })


        },


  }
}
</script>


<style lang="scss">
  .ImportHistoryComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    .button_action_undo{
        margin: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ImportHistoryComponent.vue